export default __webpack_public_path__ + "static/media/chi1.72d6f854.webp";